export default {
	"WIN": "Won",
	ALERT_IN: "application-alert-show",
	ALERT_OUT: "application-alert-hide",
	"CASHED_OUT": "cashedOut",
	"RETURN": "Return",
	"CURRENCIES": "currency-list",
	"LOST": "Lost",
	GEOLOCATION_TRACKING_NOT_ENABLED: "geolocation-tracking-not-enabled",
	"CONVERSION_RATES": "conversion-rates",
	"SET_CONFIG": "set-config",
	"UNSETTLED": "UndecidedYet",
	"TOP_LIVE_EVENTS": "TOP_LIVE_EVENTS",
	"ODDS": "ODDS",
	"UPCOMING_EVENTS": "UPCOMING_EVENTS",
	"LIVE_ODDS": "LIVE_ODDS",
	"LAST_WINNERS": "LAST_WINNERS",
	"LOGIN_LOADING": "LOGIN_LOADING",
	"MATCH_LIST": "MATCH_LIST",
	"BANK_LIST": "BANK_LIST",
	"LIVE_MATCH_LIST": "LIVE_MATCH_LIST",
	"TOURNAMENT_LIST": "TOURNAMENT_LIST",
	"TOURNAMENT_LIST_LIVE": "TOURNAMENT_LIST_LIVE",
	"SCOREBOARD": "SCOREBOARD",
	"LIVE_SCOREBOARD": "LIVE_SCOREBOARD",
	"TEAM_STATS": "TEAM_STATS",
	"TEAM_INFO": "TEAM_INFO",
	"MOST_PLAYED_GAMES": "MOST_PLAYED_GAMES",
	"LOADING_TOURNAMENT": "LOADING_TOURNAMENT",
	"LOADING_LIVE_TOURNAMENT": "LOADING_LIVE_TOURNAMENT",
	"LOADING_MATCH_LIST": "LOADING_MATCH_LIST",
	"LOADING_LIVE_MATCH_LIST": "LOADING_LIVE_MATCH_LIST",
	"LOADING_ODD": "LOADING_ODD",
	"COUPON_LOADING": "COUPON_LOADING",
	"LOGIN_SUCCESS": "LOGIN_SUCCESS",
	"LOGOUT_SUCCESS": "LOGOUT_SUCCESS",
	"BALANCE": "balance",
	"BALANCE_UPDATED": "BALANCE_UPDATED",
	"LOAD_LIVE_MATCH": "LOAD_LIVE_MATCH",
	"LOAD_LIVE_MATCH_IN_PROGRESS": "LOAD_LIVE_MATCH_IN_PROGRESS",
	"LOAD_LIVE_MATCH_MARKET_DATA": "LOAD_LIVE_MATCH_MARKET_DATA",
	"COUPON_HISTORY_LOADED": "COUPON_HISTORY_LOADED",
	"CUSTOM_MARKET_LIST": "CUSTOM_MARKET_LIST",
	"PROFILE_HISTORY_LOADED": "PROFILE_HISTORY_LOADED",
	"PROFILE_PAYMENT_HISTORY_LOADED": "PROFILE_PAYMENT_HISTORY_LOADED",
	"PROFILE_PAYMENT_HISTORY_LOADED_UPDATE": "PROFILE_PAYMENT_HISTORY_LOADED_UPDATE",
	"PROFILE_GAME_HISTORY_LOADED": "PROFILE_GAME_HISTORY_LOADED",
	"PROFILE_GAME_HISTORY_LOADED_UPDATE": "PROFILE_GAME_HISTORY_LOADED_UPDATE",
	"PROFILE_PENDING_HISTORY_LOADED": "PROFILE_PENDING_HISTORY_LOADED",
	"PROFILE_PENDING_HISTORY_LOADED_UPDATE": "PROFILE_PENDING_HISTORY_LOADED_UPDATE",
	"PROFILE_HISTORY_LOADED_UPDATE": "PROFILE_HISTORY_LOADED_UPDATE",
	"PROFILE_HISTORY_CALL_IN_PROGRESS": "PROFILE-HISTORY-CALL-IN-PROGRESS",
	"CASINO_GAMES_LOADING": "casino-third-party-games-loading",
	"CASINO_GAME_AFFILIATE_LIST": "casino-third-party-games-affiliate-loading",
	"CASINO_GAMES_LIST": "casino-third-party-games",
	"CASINO_SEARCHED_GAMES_LIST": "casino-third-party-searched-games",
	"CASINO_GAMES_INIT_SUCCESS": "casino-third-party-games-init-success",
	"CASINO_GAME_TYPE_LIST": "casino-gametype-list",
	"CASINO_GAME_TYPE_LOADING": "casino-gametype-loading",
	"CASINO_GAME_PROVIDER_LIST": "casino-game-provider-list",
	"CASINO_GAME_PROVIDER_LOADING": "casino-game-provider-loading",
	"CASINO_GAME_CATEGORY_LIST": "casino-game-category-list",
	"CASINO_GAME_CATEGORY_LOADING": "casino-game-category-loading",
	"APP_BONUS_LIST": "app-bonus-list",
	"APP_FILTERED_BONUS_LIST": "app-filtered-bonus-list",
	"APP_VISIBLE_BONUS_LIST": "app-visible-bonus-list",
	"PRESENT_BOX_VISIBILITY": "present-box-visibility",
	"APP_BONUS_LOADING": "app-bonus-loading",
	"USER_NOTIFICATION": "notifications",
	"INBOX_LIST": "inbox-list",
	"NOTIFICATION_COUNTER": "notification-counter",
	"INBOX_LOADING": "inbox-loading",
	"PROFILE_LOADING": "profile-loading",
	"CONTAINER_CONTENT": "container-content",
	"DEPOSIT_LOADING": "deposit-loading",
	"GET_ALL_DOCUMENTS": "get-all-documents",
	"GET_ALL_DOCUMENTS_LOADING": "get-all-documents-loading",
	"WITHDRAW_LOADING": "withdraw-loading",
	"DEPOSIT_PAYMENT_METHODS": "deposit-payment-methods",
	"WITHDRAW_PAYMENT_METHODS": "withdraw-payment-methods",
	"ODENDIBIL_TYPES": "odendibil-types",
	"ODENDIBIL_BANKS": "odendibil-banks",
	"UNAPPROVED_DOCUMENT": "unapproved-document",
	"MISSING_DOCUMENT": "missing-document",
	"PROFILE_DATA": "profile-data",
	"LIVE_CASINO_LAUNCH_SUCCESS": "ezugi-launch--success",
	"LIVE_CASINO_LAUNCH_LOADING": "ezugi-launch-url-loading",
	"LIVE_CASINO_LAUNCH_ERROR": "ezugi-launch-url-error",
	"GET_USER_AVAILABLE_BONUSES_LOADING": "user-available-bonuses-loading",
	"GET_USER_AVAILABLE_BONUSES_SUCCESS": "user-available-bonuses-success",
	"UPDATE_USER_AVAILABLE_BONUSES_SUCCESS": "user-available-bonuses-update-success",
	"GET_USER_AVAILABLE_BONUSES_ERROR": "user-available-bonuses-error",
	"CLEAR_USER_AVAILABLE_BONUSES": "clear-user-available-bonuses",
	"GET_ACTIVE_BONUS_PRESENT_LIST": "bonus-present-list",
	"GET_ACTIVE_BONUS_PRESENT_LOADING": "bonus-present-loading",
	"GET_ACTIVE_BONUS_CONTENT": "bonus-present-content",
	"GET_ACTIVE_BONUS_CLICK_TIME": "bonus-present-click-time",
	"UPDATE_LIST_BONUS_HISTORY": "update-list-bonus-history",
	"ADJUST_INBOX": "adjust-inbox",
	"PROFILE_FREESPIN_HISTORY_LOADED_UPDATE": "profile-freespin-history-list-update",
	"PROFILE_FREESPIN_HISTORY_LOADED": "profile-freespin-history-list",
	"CLEAR_3PARTY_PROVIDERS": "clear-third-party-providers",
	"LIST_BONUS_HISTORY": "list-bonus-history",
	"UNAUTH_ERROR": "unauth-error",
	"SESSION_ENDED": "SessionEnded",
	"FAVORITE_GAMES": "casinounited-favorite-games",
	"CASINO_CONTAINER_CONFIGS": "casinounited-contianer-configs",
	"CASINO_CONTAINER_CONFIGS_LOADING": "casinounited-contianer-configs-loading",
	"REDUCE_NOTIFICATION_COUNTER": "reduce-notification-counter",
	"SESSION_RESET": "SessionReset",
	"PROFILE_UPDATE_REQUIRED": "profile-update-required",
};

export const CURRENCIES = [
	{ "cc": "AED", "symbol": "\u062f.\u0625;", "name": "UAE dirham" },
	{ "cc": "AFN", "symbol": "Afs", "name": "Afghan afghani" },
	{ "cc": "ALL", "symbol": "L", "name": "Albanian lek" },
	{ "cc": "AMD", "symbol": "AMD", "name": "Armenian dram" },
	{ "cc": "ANG", "symbol": "NA\u0192", "name": "Netherlands Antillean gulden" },
	{ "cc": "AOA", "symbol": "Kz", "name": "Angolan kwanza" },
	{ "cc": "ARS", "symbol": "$", "name": "Argentine peso" },
	{ "cc": "AUD", "symbol": "$", "name": "Australian dollar" },
	{ "cc": "AWG", "symbol": "\u0192", "name": "Aruban florin" },
	{ "cc": "AZN", "symbol": "AZN", "name": "Azerbaijani manat" },
	{ "cc": "BAM", "symbol": "KM", "name": "Bosnia and Herzegovina konvertibilna marka" },
	{ "cc": "BBD", "symbol": "Bds$", "name": "Barbadian dollar" },
	{ "cc": "BDT", "symbol": "\u09f3", "name": "Bangladeshi taka" },
	{ "cc": "BGN", "symbol": "BGN", "name": "Bulgarian lev" },
	{ "cc": "BHD", "symbol": ".\u062f.\u0628", "name": "Bahraini dinar" },
	{ "cc": "BIF", "symbol": "FBu", "name": "Burundi franc" },
	{ "cc": "BMD", "symbol": "BD$", "name": "Bermudian dollar" },
	{ "cc": "BND", "symbol": "B$", "name": "Brunei dollar" },
	{ "cc": "BOB", "symbol": "Bs.", "name": "Bolivian boliviano" },
	{ "cc": "BRL", "symbol": "R$", "name": "Brazilian real" },
	{ "cc": "BSD", "symbol": "B$", "name": "Bahamian dollar" },
	{ "cc": "BTN", "symbol": "Nu.", "name": "Bhutanese ngultrum" },
	{ "cc": "BWP", "symbol": "P", "name": "Botswana pula" },
	{ "cc": "BYR", "symbol": "Br", "name": "Belarusian ruble" },
	{ "cc": "BZD", "symbol": "BZ$", "name": "Belize dollar" },
	{ "cc": "CAD", "symbol": "$", "name": "Canadian dollar" },
	{ "cc": "CDF", "symbol": "F", "name": "Congolese franc" },
	{ "cc": "CHF", "symbol": "Fr.", "name": "Swiss franc" },
	{ "cc": "CLP", "symbol": "$", "name": "Chilean peso" },
	{ "cc": "CNY", "symbol": "\u00a5", "name": "Chinese/Yuan renminbi" },
	{ "cc": "COP", "symbol": "Col$", "name": "Colombian peso" },
	{ "cc": "CRC", "symbol": "\u20a1", "name": "Costa Rican colon" },
	{ "cc": "CUC", "symbol": "$", "name": "Cuban peso" },
	{ "cc": "CVE", "symbol": "Esc", "name": "Cape Verdean escudo" },
	{ "cc": "CZK", "symbol": "K\u010d", "name": "Czech koruna" },
	{ "cc": "DJF", "symbol": "Fdj", "name": "Djiboutian franc" },
	{ "cc": "DKK", "symbol": "Kr", "name": "Danish krone" },
	{ "cc": "DOP", "symbol": "RD$", "name": "Dominican peso" },
	{ "cc": "DZD", "symbol": "\u062f.\u062c", "name": "Algerian dinar" },
	{ "cc": "EEK", "symbol": "KR", "name": "Estonian kroon" },
	{ "cc": "EGP", "symbol": "\u00a3", "name": "Egyptian pound" },
	{ "cc": "ERN", "symbol": "Nfa", "name": "Eritrean nakfa" },
	{ "cc": "ETB", "symbol": "Br", "name": "Ethiopian birr" },
	{ "cc": "EUR", "symbol": "\u20ac", "name": "European Euro" },
	{ "cc": "FJD", "symbol": "FJ$", "name": "Fijian dollar" },
	{ "cc": "FKP", "symbol": "\u00a3", "name": "Falkland Islands pound" },
	{ "cc": "GBP", "symbol": "\u00a3", "name": "British pound" },
	{ "cc": "GEL", "symbol": "GEL", "name": "Georgian lari" },
	{ "cc": "GHS", "symbol": "GH\u20b5", "name": "Ghanaian cedi" },
	{ "cc": "GIP", "symbol": "\u00a3", "name": "Gibraltar pound" },
	{ "cc": "GMD", "symbol": "D", "name": "Gambian dalasi" },
	{ "cc": "GNF", "symbol": "FG", "name": "Guinean franc" },
	{ "cc": "GQE", "symbol": "CFA", "name": "Central African CFA franc" },
	{ "cc": "GTQ", "symbol": "Q", "name": "Guatemalan quetzal" },
	{ "cc": "GYD", "symbol": "GY$", "name": "Guyanese dollar" },
	{ "cc": "HKD", "symbol": "HK$", "name": "Hong Kong dollar" },
	{ "cc": "HNL", "symbol": "L", "name": "Honduran lempira" },
	{ "cc": "HRK", "symbol": "kn", "name": "Croatian kuna" },
	{ "cc": "HTG", "symbol": "G", "name": "Haitian gourde" },
	{ "cc": "HUF", "symbol": "Ft", "name": "Hungarian forint" },
	{ "cc": "IDR", "symbol": "Rp", "name": "Indonesian rupiah" },
	{ "cc": "ILS", "symbol": "\u20aa", "name": "Israeli new sheqel" },
	{ "cc": "INR", "symbol": "\u20B9", "name": "Indian rupee" },
	{ "cc": "IQD", "symbol": "\u062f.\u0639", "name": "Iraqi dinar" },
	{ "cc": "IRR", "symbol": "IRR", "name": "Iranian rial" },
	{ "cc": "ISK", "symbol": "kr", "name": "Icelandic kr\u00f3na" },
	{ "cc": "JMD", "symbol": "J$", "name": "Jamaican dollar" },
	{ "cc": "JOD", "symbol": "JOD", "name": "Jordanian dinar" },
	{ "cc": "JPY", "symbol": "\u00a5", "name": "Japanese yen" },
	{ "cc": "KES", "symbol": "KSh", "name": "Kenyan shilling" },
	{ "cc": "KGS", "symbol": "\u0441\u043e\u043c", "name": "Kyrgyzstani som" },
	{ "cc": "KHR", "symbol": "\u17db", "name": "Cambodian riel" },
	{ "cc": "KMF", "symbol": "KMF", "name": "Comorian franc" },
	{ "cc": "KPW", "symbol": "W", "name": "North Korean won" },
	{ "cc": "KRW", "symbol": "W", "name": "South Korean won" },
	{ "cc": "KWD", "symbol": "KWD", "name": "Kuwaiti dinar" },
	{ "cc": "KYD", "symbol": "KY$", "name": "Cayman Islands dollar" },
	{ "cc": "KZT", "symbol": "T", "name": "Kazakhstani tenge" },
	{ "cc": "LAK", "symbol": "KN", "name": "Lao kip" },
	{ "cc": "LBP", "symbol": "\u00a3", "name": "Lebanese lira" },
	{ "cc": "LKR", "symbol": "Rs", "name": "Sri Lankan rupee" },
	{ "cc": "LRD", "symbol": "L$", "name": "Liberian dollar" },
	{ "cc": "LSL", "symbol": "M", "name": "Lesotho loti" },
	{ "cc": "LTL", "symbol": "Lt", "name": "Lithuanian litas" },
	{ "cc": "LVL", "symbol": "Ls", "name": "Latvian lats" },
	{ "cc": "LYD", "symbol": "LD", "name": "Libyan dinar" },
	{ "cc": "MAD", "symbol": "MAD", "name": "Moroccan dirham" },
	{ "cc": "MDL", "symbol": "MDL", "name": "Moldovan leu" },
	{ "cc": "MGA", "symbol": "FMG", "name": "Malagasy ariary" },
	{ "cc": "MKD", "symbol": "MKD", "name": "Macedonian denar" },
	{ "cc": "MMK", "symbol": "K", "name": "Myanma kyat" },
	{ "cc": "MNT", "symbol": "\u20ae", "name": "Mongolian tugrik" },
	{ "cc": "MOP", "symbol": "P", "name": "Macanese pataca" },
	{ "cc": "MRO", "symbol": "UM", "name": "Mauritanian ouguiya" },
	{ "cc": "MUR", "symbol": "Rs", "name": "Mauritian rupee" },
	{ "cc": "MVR", "symbol": "Rf", "name": "Maldivian rufiyaa" },
	{ "cc": "MWK", "symbol": "MK", "name": "Malawian kwacha" },
	{ "cc": "MXN", "symbol": "$", "name": "Mexican peso" },
	{ "cc": "MYR", "symbol": "RM", "name": "Malaysian ringgit" },
	{ "cc": "MZM", "symbol": "MTn", "name": "Mozambican metical" },
	{ "cc": "NAD", "symbol": "N$", "name": "Namibian dollar" },
	{ "cc": "NGN", "symbol": "\u20a6", "name": "Nigerian naira" },
	{ "cc": "NIO", "symbol": "C$", "name": "Nicaraguan c\u00f3rdoba" },
	{ "cc": "NOK", "symbol": "kr", "name": "Norwegian krone" },
	{ "cc": "NPR", "symbol": "NRs", "name": "Nepalese rupee" },
	{ "cc": "NZD", "symbol": "NZ$", "name": "New Zealand dollar" },
	{ "cc": "OMR", "symbol": "OMR", "name": "Omani rial" },
	{ "cc": "PAB", "symbol": "B./", "name": "Panamanian balboa" },
	{ "cc": "PEN", "symbol": "S/.", "name": "Peruvian nuevo sol" },
	{ "cc": "PGK", "symbol": "K", "name": "Papua New Guinean kina" },
	{ "cc": "PHP", "symbol": "\u20b1", "name": "Philippine peso" },
	{ "cc": "PKR", "symbol": "Rs.", "name": "Pakistani rupee" },
	{ "cc": "PLN", "symbol": "z\u0142", "name": "Polish zloty" },
	{ "cc": "PYG", "symbol": "\u20b2", "name": "Paraguayan guarani" },
	{ "cc": "QAR", "symbol": "QR", "name": "Qatari riyal" },
	{ "cc": "RON", "symbol": "L", "name": "Romanian leu" },
	{ "cc": "RSD", "symbol": "din.", "name": "Serbian dinar" },
	{ "cc": "RUB", "symbol": "R", "name": "Russian ruble" },
	{ "cc": "SAR", "symbol": "SR", "name": "Saudi riyal" },
	{ "cc": "SBD", "symbol": "SI$", "name": "Solomon Islands dollar" },
	{ "cc": "SCR", "symbol": "SR", "name": "Seychellois rupee" },
	{ "cc": "SDG", "symbol": "SDG", "name": "Sudanese pound" },
	{ "cc": "SEK", "symbol": "kr", "name": "Swedish krona" },
	{ "cc": "SGD", "symbol": "S$", "name": "Singapore dollar" },
	{ "cc": "SHP", "symbol": "\u00a3", "name": "Saint Helena pound" },
	{ "cc": "SLL", "symbol": "Le", "name": "Sierra Leonean leone" },
	{ "cc": "SOS", "symbol": "Sh.", "name": "Somali shilling" },
	{ "cc": "SRD", "symbol": "$", "name": "Surinamese dollar" },
	{ "cc": "SYP", "symbol": "LS", "name": "Syrian pound" },
	{ "cc": "SZL", "symbol": "E", "name": "Swazi lilangeni" },
	{ "cc": "THB", "symbol": "\u0e3f", "name": "Thai baht" },
	{ "cc": "TJS", "symbol": "TJS", "name": "Tajikistani somoni" },
	{ "cc": "TMT", "symbol": "m", "name": "Turkmen manat" },
	{ "cc": "TND", "symbol": "DT", "name": "Tunisian dinar" },
	{ "cc": "TRY", "symbol": "TRY", "name": "Turkish new lira" },
	{ "cc": "TTD", "symbol": "TT$", "name": "Trinidad and Tobago dollar" },
	{ "cc": "TWD", "symbol": "NT$", "name": "New Taiwan dollar" },
	{ "cc": "TZS", "symbol": "TZS", "name": "Tanzanian shilling" },
	{ "cc": "UAH", "symbol": "UAH", "name": "Ukrainian hryvnia" },
	{ "cc": "UGX", "symbol": "USh", "name": "Ugandan shilling" },
	{ "cc": "USD", "symbol": "US$", "name": "United States dollar" },
	{ "cc": "UYU", "symbol": "$U", "name": "Uruguayan peso" },
	{ "cc": "UZS", "symbol": "UZS", "name": "Uzbekistani som" },
	{ "cc": "VEB", "symbol": "Bs", "name": "Venezuelan bolivar" },
	{ "cc": "VES", "symbol": "Bs.", "name": "Venezuelan bolivar sólido" },
	{ "cc": "VND", "symbol": "\u20ab", "name": "Vietnamese dong" },
	{ "cc": "VUV", "symbol": "VT", "name": "Vanuatu vatu" },
	{ "cc": "WST", "symbol": "WS$", "name": "Samoan tala" },
	{ "cc": "XAF", "symbol": "CFA", "name": "Central African CFA franc" },
	{ "cc": "XCD", "symbol": "EC$", "name": "East Caribbean dollar" },
	{ "cc": "XDR", "symbol": "SDR", "name": "Special Drawing Rights" },
	{ "cc": "XOF", "symbol": "CFA", "name": "West African CFA franc" },
	{ "cc": "XPF", "symbol": "F", "name": "CFP franc" },
	{ "cc": "YER", "symbol": "YER", "name": "Yemeni rial" },
	{ "cc": "ZAR", "symbol": "R", "name": "South African rand" },
	{ "cc": "ZMK", "symbol": "ZK", "name": "Zambian kwacha" },
	{ "cc": "mBTC", "symbol": "mBTC", "name": "mBTC" },
	{ "cc": "ZWR", "symbol": "Z$", "name": "Zimbabwean dollar" },
];

export const LANGUAGES = [
	{ code: "en", text: "ENGLISH" },
	{ code: "tr", text: "TÜRKÇE" },
	{ code: "pt", text: "PORTUGUÊS" },
	{ code: "br", text: "PORTUGUÊS(BR)" },
	{ code: "es", text: "MX" },
	{ code: "ru", text: "РУССКИЙ" },
	{ code: "it", text: "ITALIANO" },
	{ code: "th", text: "THAI" },
	{ code: "fa", text: "فارسی" },
].filter((i) => (window.SUPPORTED_LANGS ? window.SUPPORTED_LANGS.includes(i.code) : true));

export const SECRET_QUESTIONS = [
	"WHAT_IS_THE_NAME_OF_YOUR_FIRST_LOVE",
	"WHAT_WAS_YOUR_CHILDHOOD_NICKNAME",
	"WHAT_IS_THE_NAME_OF_YOUR_FAVORITE_CHILDHOOD_FRIEND",
	"WHAT_IS_YOUR_FAVORITE_MOVIE",
	"IN_WHAT_TOWN_WAS_YOUR_FIRST_JOB",
];

function prioritizeMainPhoneCode(arr) {
	if (typeof window === "undefined" || !window.MAIN_PHONE_CODE) return arr;
	const idx = arr.findIndex((c) => c.code === window.MAIN_PHONE_CODE);
	if (idx > 0) {
		const [main] = arr.splice(idx, 1);
		arr.unshift(main);
	}
	return arr;
}

const _COUNTRY_PHONE_CODES = [
	{
		"name": "Afghanistan",
		"dial_code": "+93",
		"code": "AF",
	},
	{
		"name": "Albania",
		"dial_code": "+355",
		"code": "AL",
	},
	{
		"name": "Algeria",
		"dial_code": "+213",
		"code": "DZ",
	},
	{
		"name": "AmericanSamoa",
		"dial_code": "+1 684",
		"code": "AS",
	},
	{
		"name": "Andorra",
		"dial_code": "+376",
		"code": "AD",
	},
	{
		"name": "Angola",
		"dial_code": "+244",
		"code": "AO",
	},
	{
		"name": "Anguilla",
		"dial_code": "+1 264",
		"code": "AI",
	},
	{
		"name": "Antigua and Barbuda",
		"dial_code": "+1268",
		"code": "AG",
	},
	{
		"name": "Argentina",
		"dial_code": "+54",
		"code": "AR",
	},
	{
		"name": "Armenia",
		"dial_code": "+374",
		"code": "AM",
	},
	{
		"name": "Aruba",
		"dial_code": "+297",
		"code": "AW",
	},
	{
		"name": "Australia",
		"dial_code": "+61",
		"code": "AU",
	},
	{
		"name": "Austria",
		"dial_code": "+43",
		"code": "AT",
	},
	{
		"name": "Azerbaijan",
		"dial_code": "+994",
		"code": "AZ",
	},
	{
		"name": "Bahamas",
		"dial_code": "+1 242",
		"code": "BS",
	},
	{
		"name": "Bahrain",
		"dial_code": "+973",
		"code": "BH",
	},
	{
		"name": "Bangladesh",
		"dial_code": "+880",
		"code": "BD",
	},
	{
		"name": "Barbados",
		"dial_code": "+1 246",
		"code": "BB",
	},
	{
		"name": "Belarus",
		"dial_code": "+375",
		"code": "BY",
	},
	{
		"name": "Belgium",
		"dial_code": "+32",
		"code": "BE",
	},
	{
		"name": "Belize",
		"dial_code": "+501",
		"code": "BZ",
	},
	{
		"name": "Benin",
		"dial_code": "+229",
		"code": "BJ",
	},
	{
		"name": "Bermuda",
		"dial_code": "+1 441",
		"code": "BM",
	},
	{
		"name": "Bhutan",
		"dial_code": "+975",
		"code": "BT",
	},
	{
		"name": "Bosnia and Herzegovina",
		"dial_code": "+387",
		"code": "BA",
	},
	{
		"name": "Botswana",
		"dial_code": "+267",
		"code": "BW",
	},
	{
		"name": "Brazil",
		"dial_code": "+55",
		"code": "BR",
	},
	{
		"name": "British Indian Ocean Territory",
		"dial_code": "+246",
		"code": "IO",
	},
	{
		"name": "Bulgaria",
		"dial_code": "+359",
		"code": "BG",
	},
	{
		"name": "Burkina Faso",
		"dial_code": "+226",
		"code": "BF",
	},
	{
		"name": "Burundi",
		"dial_code": "+257",
		"code": "BI",
	},
	{
		"name": "Cambodia",
		"dial_code": "+855",
		"code": "KH",
	},
	{
		"name": "Cameroon",
		"dial_code": "+237",
		"code": "CM",
	},
	{
		"name": "Canada",
		"dial_code": "+1",
		"code": "CA",
	},
	{
		"name": "Cape Verde",
		"dial_code": "+238",
		"code": "CV",
	},
	{
		"name": "Cayman Islands",
		"dial_code": "+ 345",
		"code": "KY",
	},
	{
		"name": "Central African Republic",
		"dial_code": "+236",
		"code": "CF",
	},
	{
		"name": "Chad",
		"dial_code": "+235",
		"code": "TD",
	},
	{
		"name": "Chile",
		"dial_code": "+56",
		"code": "CL",
	},
	{
		"name": "China",
		"dial_code": "+86",
		"code": "CN",
	},
	{
		"name": "Christmas Island",
		"dial_code": "+61",
		"code": "CX",
	},
	{
		"name": "Colombia",
		"dial_code": "+57",
		"code": "CO",
	},
	{
		"name": "Comoros",
		"dial_code": "+269",
		"code": "KM",
	},
	{
		"name": "Congo",
		"dial_code": "+242",
		"code": "CG",
	},
	{
		"name": "Cook Islands",
		"dial_code": "+682",
		"code": "CK",
	},
	{
		"name": "Costa Rica",
		"dial_code": "+506",
		"code": "CR",
	},
	{
		"name": "Croatia",
		"dial_code": "+385",
		"code": "HR",
	},
	{
		"name": "Cuba",
		"dial_code": "+53",
		"code": "CU",
	},
	{
		"name": "Cyprus",
		"dial_code": "+357",
		"code": "CY",
	},
	{
		"name": "Czech Republic",
		"dial_code": "+420",
		"code": "CZ",
	},
	{
		"name": "Denmark",
		"dial_code": "+45",
		"code": "DK",
	},
	{
		"name": "Djibouti",
		"dial_code": "+253",
		"code": "DJ",
	},
	{
		"name": "Dominica",
		"dial_code": "+1 767",
		"code": "DM",
	},
	{
		"name": "Dominican Republic",
		"dial_code": "+1 849",
		"code": "DO",
	},
	{
		"name": "Ecuador",
		"dial_code": "+593",
		"code": "EC",
	},
	{
		"name": "Egypt",
		"dial_code": "+20",
		"code": "EG",
	},
	{
		"name": "El Salvador",
		"dial_code": "+503",
		"code": "SV",
	},
	{
		"name": "Equatorial Guinea",
		"dial_code": "+240",
		"code": "GQ",
	},
	{
		"name": "Eritrea",
		"dial_code": "+291",
		"code": "ER",
	},
	{
		"name": "Estonia",
		"dial_code": "+372",
		"code": "EE",
	},
	{
		"name": "Ethiopia",
		"dial_code": "+251",
		"code": "ET",
	},
	{
		"name": "Faroe Islands",
		"dial_code": "+298",
		"code": "FO",
	},
	{
		"name": "Fiji",
		"dial_code": "+679",
		"code": "FJ",
	},
	{
		"name": "Finland",
		"dial_code": "+358",
		"code": "FI",
	},
	{
		"name": "France",
		"dial_code": "+33",
		"code": "FR",
	},
	{
		"name": "French Guiana",
		"dial_code": "+594",
		"code": "GF",
	},
	{
		"name": "French Polynesia",
		"dial_code": "+689",
		"code": "PF",
	},
	{
		"name": "Gabon",
		"dial_code": "+241",
		"code": "GA",
	},
	{
		"name": "Gambia",
		"dial_code": "+220",
		"code": "GM",
	},
	{
		"name": "Georgia",
		"dial_code": "+995",
		"code": "GE",
	},
	{
		"name": "Germany",
		"dial_code": "+49",
		"code": "DE",
	},
	{
		"name": "Ghana",
		"dial_code": "+233",
		"code": "GH",
	},
	{
		"name": "Gibraltar",
		"dial_code": "+350",
		"code": "GI",
	},
	{
		"name": "Greece",
		"dial_code": "+30",
		"code": "GR",
	},
	{
		"name": "Greenland",
		"dial_code": "+299",
		"code": "GL",
	},
	{
		"name": "Grenada",
		"dial_code": "+1 473",
		"code": "GD",
	},
	{
		"name": "Guadeloupe",
		"dial_code": "+590",
		"code": "GP",
	},
	{
		"name": "Guam",
		"dial_code": "+1 671",
		"code": "GU",
	},
	{
		"name": "Guatemala",
		"dial_code": "+502",
		"code": "GT",
	},
	{
		"name": "Guinea",
		"dial_code": "+224",
		"code": "GN",
	},
	{
		"name": "Guinea-Bissau",
		"dial_code": "+245",
		"code": "GW",
	},
	{
		"name": "Guyana",
		"dial_code": "+595",
		"code": "GY",
	},
	{
		"name": "Haiti",
		"dial_code": "+509",
		"code": "HT",
	},
	{
		"name": "Honduras",
		"dial_code": "+504",
		"code": "HN",
	},
	{
		"name": "Hungary",
		"dial_code": "+36",
		"code": "HU",
	},
	{
		"name": "Iceland",
		"dial_code": "+354",
		"code": "IS",
	},
	{
		"name": "India",
		"dial_code": "+91",
		"code": "IN",
	},
	{
		"name": "Indonesia",
		"dial_code": "+62",
		"code": "ID",
	},
	{
		"name": "Iraq",
		"dial_code": "+964",
		"code": "IQ",
	},
	{
		"name": "Ireland",
		"dial_code": "+353",
		"code": "IE",
	},
	{
		"name": "Israel",
		"dial_code": "+972",
		"code": "IL",
	},
	{
		"name": "Italy",
		"dial_code": "+39",
		"code": "IT",
	},
	{
		"name": "Jamaica",
		"dial_code": "+1 876",
		"code": "JM",
	},
	{
		"name": "Japan",
		"dial_code": "+81",
		"code": "JP",
	},
	{
		"name": "Jordan",
		"dial_code": "+962",
		"code": "JO",
	},
	{
		"name": "Kazakhstan",
		"dial_code": "+7 7",
		"code": "KZ",
	},
	{
		"name": "Kenya",
		"dial_code": "+254",
		"code": "KE",
	},
	{
		"name": "Kiribati",
		"dial_code": "+686",
		"code": "KI",
	},
	{
		"name": "Kuwait",
		"dial_code": "+965",
		"code": "KW",
	},
	{
		"name": "Kyrgyzstan",
		"dial_code": "+996",
		"code": "KG",
	},
	{
		"name": "Latvia",
		"dial_code": "+371",
		"code": "LV",
	},
	{
		"name": "Lebanon",
		"dial_code": "+961",
		"code": "LB",
	},
	{
		"name": "Lesotho",
		"dial_code": "+266",
		"code": "LS",
	},
	{
		"name": "Liberia",
		"dial_code": "+231",
		"code": "LR",
	},
	{
		"name": "Liechtenstein",
		"dial_code": "+423",
		"code": "LI",
	},
	{
		"name": "Lithuania",
		"dial_code": "+370",
		"code": "LT",
	},
	{
		"name": "Luxembourg",
		"dial_code": "+352",
		"code": "LU",
	},
	{
		"name": "Madagascar",
		"dial_code": "+261",
		"code": "MG",
	},
	{
		"name": "Malawi",
		"dial_code": "+265",
		"code": "MW",
	},
	{
		"name": "Malaysia",
		"dial_code": "+60",
		"code": "MY",
	},
	{
		"name": "Maldives",
		"dial_code": "+960",
		"code": "MV",
	},
	{
		"name": "Mali",
		"dial_code": "+223",
		"code": "ML",
	},
	{
		"name": "Malta",
		"dial_code": "+356",
		"code": "MT",
	},
	{
		"name": "Marshall Islands",
		"dial_code": "+692",
		"code": "MH",
	},
	{
		"name": "Martinique",
		"dial_code": "+596",
		"code": "MQ",
	},
	{
		"name": "Mauritania",
		"dial_code": "+222",
		"code": "MR",
	},
	{
		"name": "Mauritius",
		"dial_code": "+230",
		"code": "MU",
	},
	{
		"name": "Mayotte",
		"dial_code": "+262",
		"code": "YT",
	},
	{
		"name": "Mexico",
		"dial_code": "+52",
		"code": "MX",
	},
	{
		"name": "Monaco",
		"dial_code": "+377",
		"code": "MC",
	},
	{
		"name": "Mongolia",
		"dial_code": "+976",
		"code": "MN",
	},
	{
		"name": "Montenegro",
		"dial_code": "+382",
		"code": "ME",
	},
	{
		"name": "Montserrat",
		"dial_code": "+1664",
		"code": "MS",
	},
	{
		"name": "Morocco",
		"dial_code": "+212",
		"code": "MA",
	},
	{
		"name": "Myanmar",
		"dial_code": "+95",
		"code": "MM",
	},
	{
		"name": "Namibia",
		"dial_code": "+264",
		"code": "NA",
	},
	{
		"name": "Nauru",
		"dial_code": "+674",
		"code": "NR",
	},
	{
		"name": "Nepal",
		"dial_code": "+977",
		"code": "NP",
	},
	{
		"name": "Netherlands",
		"dial_code": "+31",
		"code": "NL",
	},
	{
		"name": "Netherlands Antilles",
		"dial_code": "+599",
		"code": "AN",
	},
	{
		"name": "New Caledonia",
		"dial_code": "+687",
		"code": "NC",
	},
	{
		"name": "New Zealand",
		"dial_code": "+64",
		"code": "NZ",
	},
	{
		"name": "Nicaragua",
		"dial_code": "+505",
		"code": "NI",
	},
	{
		"name": "Niger",
		"dial_code": "+227",
		"code": "NE",
	},
	{
		"name": "Nigeria",
		"dial_code": "+234",
		"code": "NG",
	},
	{
		"name": "Niue",
		"dial_code": "+683",
		"code": "NU",
	},
	{
		"name": "Norfolk Island",
		"dial_code": "+672",
		"code": "NF",
	},
	{
		"name": "Northern Mariana Islands",
		"dial_code": "+1 670",
		"code": "MP",
	},
	{
		"name": "Norway",
		"dial_code": "+47",
		"code": "NO",
	},
	{
		"name": "Oman",
		"dial_code": "+968",
		"code": "OM",
	},
	{
		"name": "Pakistan",
		"dial_code": "+92",
		"code": "PK",
	},
	{
		"name": "Palau",
		"dial_code": "+680",
		"code": "PW",
	},
	{
		"name": "Panama",
		"dial_code": "+507",
		"code": "PA",
	},
	{
		"name": "Papua New Guinea",
		"dial_code": "+675",
		"code": "PG",
	},
	{
		"name": "Paraguay",
		"dial_code": "+595",
		"code": "PY",
	},
	{
		"name": "Peru",
		"dial_code": "+51",
		"code": "PE",
	},
	{
		"name": "Philippines",
		"dial_code": "+63",
		"code": "PH",
	},
	{
		"name": "Poland",
		"dial_code": "+48",
		"code": "PL",
	},
	{
		"name": "Portugal",
		"dial_code": "+351",
		"code": "PT",
	},
	{
		"name": "Puerto Rico",
		"dial_code": "+1 939",
		"code": "PR",
	},
	{
		"name": "Qatar",
		"dial_code": "+974",
		"code": "QA",
	},
	{
		"name": "Romania",
		"dial_code": "+40",
		"code": "RO",
	},
	{
		"name": "Rwanda",
		"dial_code": "+250",
		"code": "RW",
	},
	{
		"name": "Samoa",
		"dial_code": "+685",
		"code": "WS",
	},
	{
		"name": "San Marino",
		"dial_code": "+378",
		"code": "SM",
	},
	{
		"name": "Saudi Arabia",
		"dial_code": "+966",
		"code": "SA",
	},
	{
		"name": "Senegal",
		"dial_code": "+221",
		"code": "SN",
	},
	{
		"name": "Serbia",
		"dial_code": "+381",
		"code": "RS",
	},
	{
		"name": "Seychelles",
		"dial_code": "+248",
		"code": "SC",
	},
	{
		"name": "Sierra Leone",
		"dial_code": "+232",
		"code": "SL",
	},
	{
		"name": "Singapore",
		"dial_code": "+65",
		"code": "SG",
	},
	{
		"name": "Slovakia",
		"dial_code": "+421",
		"code": "SK",
	},
	{
		"name": "Slovenia",
		"dial_code": "+386",
		"code": "SI",
	},
	{
		"name": "Solomon Islands",
		"dial_code": "+677",
		"code": "SB",
	},
	{
		"name": "South Africa",
		"dial_code": "+27",
		"code": "ZA",
	},
	{
		"name": "South Georgia and the South Sandwich Islands",
		"dial_code": "+500",
		"code": "GS",
	},
	{
		"name": "Spain",
		"dial_code": "+34",
		"code": "ES",
	},
	{
		"name": "Sri Lanka",
		"dial_code": "+94",
		"code": "LK",
	},
	{
		"name": "Sudan",
		"dial_code": "+249",
		"code": "SD",
	},
	{
		"name": "Suriname",
		"dial_code": "+597",
		"code": "SR",
	},
	{
		"name": "Swaziland",
		"dial_code": "+268",
		"code": "SZ",
	},
	{
		"name": "Sweden",
		"dial_code": "+46",
		"code": "SE",
	},
	{
		"name": "Switzerland",
		"dial_code": "+41",
		"code": "CH",
	},
	{
		"name": "Tajikistan",
		"dial_code": "+992",
		"code": "TJ",
	},
	{
		"name": "Thailand",
		"dial_code": "+66",
		"code": "TH",
	},
	{
		"name": "Togo",
		"dial_code": "+228",
		"code": "TG",
	},
	{
		"name": "Tokelau",
		"dial_code": "+690",
		"code": "TK",
	},
	{
		"name": "Tonga",
		"dial_code": "+676",
		"code": "TO",
	},
	{
		"name": "Trinidad and Tobago",
		"dial_code": "+1 868",
		"code": "TT",
	},
	{
		"name": "Tunisia",
		"dial_code": "+216",
		"code": "TN",
	},
	{
		"name": "Turkey",
		"dial_code": "+90",
		"code": "TR",
	},
	{
		"name": "Turkmenistan",
		"dial_code": "+993",
		"code": "TM",
	},
	{
		"name": "Turks and Caicos Islands",
		"dial_code": "+1 649",
		"code": "TC",
	},
	{
		"name": "Tuvalu",
		"dial_code": "+688",
		"code": "TV",
	},
	{
		"name": "Uganda",
		"dial_code": "+256",
		"code": "UG",
	},
	{
		"name": "Ukraine",
		"dial_code": "+380",
		"code": "UA",
	},
	{
		"name": "United Arab Emirates",
		"dial_code": "+971",
		"code": "AE",
	},
	{
		"name": "United Kingdom",
		"dial_code": "+44",
		"code": "GB",
	},
	{
		"name": "United States",
		"dial_code": "+1",
		"code": "US",
	},
	{
		"name": "Uruguay",
		"dial_code": "+598",
		"code": "UY",
	},
	{
		"name": "Uzbekistan",
		"dial_code": "+998",
		"code": "UZ",
	},
	{
		"name": "Vanuatu",
		"dial_code": "+678",
		"code": "VU",
	},
	{
		"name": "Wallis and Futuna",
		"dial_code": "+681",
		"code": "WF",
	},
	{
		"name": "Yemen",
		"dial_code": "+967",
		"code": "YE",
	},
	{
		"name": "Zambia",
		"dial_code": "+260",
		"code": "ZM",
	},
	{
		"name": "Zimbabwe",
		"dial_code": "+263",
		"code": "ZW",
	},
	{
		"name": "land Islands",
		"dial_code": "",
		"code": "AX",
	},
	{
		"name": "Antarctica",
		"dial_code": null,
		"code": "AQ",
	},
	{
		"name": "Bolivia, Plurinational State of",
		"dial_code": "+591",
		"code": "BO",
	},
	{
		"name": "Brunei Darussalam",
		"dial_code": "+673",
		"code": "BN",
	},
	{
		"name": "Cocos (Keeling) Islands",
		"dial_code": "+61",
		"code": "CC",
	},
	{
		"name": "Congo, The Democratic Republic of the",
		"dial_code": "+243",
		"code": "CD",
	},
	{
		"name": "Cote d'Ivoire",
		"dial_code": "+225",
		"code": "CI",
	},
	{
		"name": "Falkland Islands (Malvinas)",
		"dial_code": "+500",
		"code": "FK",
	},
	{
		"name": "Guernsey",
		"dial_code": "+44",
		"code": "GG",
	},
	{
		"name": "Holy See (Vatican City State)",
		"dial_code": "+379",
		"code": "VA",
	},
	{
		"name": "Hong Kong",
		"dial_code": "+852",
		"code": "HK",
	},
	{
		"name": "Iran, Islamic Republic of",
		"dial_code": "+98",
		"code": "IR",
	},
	{
		"name": "Isle of Man",
		"dial_code": "+44",
		"code": "IM",
	},
	{
		"name": "Jersey",
		"dial_code": "+44",
		"code": "JE",
	},
	{
		"name": "Korea, Democratic People's Republic of",
		"dial_code": "+850",
		"code": "KP",
	},
	{
		"name": "Korea, Republic of",
		"dial_code": "+82",
		"code": "KR",
	},
	{
		"name": "Lao People's Democratic Republic",
		"dial_code": "+856",
		"code": "LA",
	},
	{
		"name": "Libyan Arab Jamahiriya",
		"dial_code": "+218",
		"code": "LY",
	},
	{
		"name": "Macao",
		"dial_code": "+853",
		"code": "MO",
	},
	{
		"name": "Macedonia, The Former Yugoslav Republic of",
		"dial_code": "+389",
		"code": "MK",
	},
	{
		"name": "Micronesia, Federated States of",
		"dial_code": "+691",
		"code": "FM",
	},
	{
		"name": "Moldova, Republic of",
		"dial_code": "+373",
		"code": "MD",
	},
	{
		"name": "Mozambique",
		"dial_code": "+258",
		"code": "MZ",
	},
	{
		"name": "Palestinian Territory, Occupied",
		"dial_code": "+970",
		"code": "PS",
	},
	{
		"name": "Pitcairn",
		"dial_code": "+872",
		"code": "PN",
	},
	{
		"name": "Réunion",
		"dial_code": "+262",
		"code": "RE",
	},
	{
		"name": "Russia",
		"dial_code": "+7",
		"code": "RU",
	},
	{
		"name": "Saint Barthélemy",
		"dial_code": "+590",
		"code": "BL",
	},
	{
		"name": "Saint Helena, Ascension and Tristan Da Cunha",
		"dial_code": "+290",
		"code": "SH",
	},
	{
		"name": "Saint Kitts and Nevis",
		"dial_code": "+1 869",
		"code": "KN",
	},
	{
		"name": "Saint Lucia",
		"dial_code": "+1 758",
		"code": "LC",
	},
	{
		"name": "Saint Martin",
		"dial_code": "+590",
		"code": "MF",
	},
	{
		"name": "Saint Pierre and Miquelon",
		"dial_code": "+508",
		"code": "PM",
	},
	{
		"name": "Saint Vincent and the Grenadines",
		"dial_code": "+1 784",
		"code": "VC",
	},
	{
		"name": "Sao Tome and Principe",
		"dial_code": "+239",
		"code": "ST",
	},
	{
		"name": "Somalia",
		"dial_code": "+252",
		"code": "SO",
	},
	{
		"name": "Svalbard and Jan Mayen",
		"dial_code": "+47",
		"code": "SJ",
	},
	{
		"name": "Syrian Arab Republic",
		"dial_code": "+963",
		"code": "SY",
	},
	{
		"name": "Taiwan, Province of China",
		"dial_code": "+886",
		"code": "TW",
	},
	{
		"name": "Tanzania, United Republic of",
		"dial_code": "+255",
		"code": "TZ",
	},
	{
		"name": "Timor-Leste",
		"dial_code": "+670",
		"code": "TL",
	},
	{
		"name": "Venezuela, Bolivarian Republic of",
		"dial_code": "+58",
		"code": "VE",
	},
	{
		"name": "Viet Nam",
		"dial_code": "+84",
		"code": "VN",
	},
	{
		"name": "Virgin Islands, British",
		"dial_code": "+1 284",
		"code": "VG",
	},
	{
		"name": "Virgin Islands, U.S.",
		"dial_code": "+1 340",
		"code": "VI",
	},
].filter((country) => !window.DISABLED_PHONE_CODES?.includes(country.code));

export const COUNTRY_PHONE_CODES = prioritizeMainPhoneCode(_COUNTRY_PHONE_CODES);

export const GANNAR_COUNTRIES = ["CL", "HN", "VE", "NI", "GT", "AR"];

export const PHONE_CODE_TO_COUNTRY = {
	"+56": "CL", // Chile
	"+504": "HN", // Honduras
	"+58": "VE", // Venezuela
	"+505": "NI", // Nicaragua
	"+502": "GT", // Guatemala
	"+54": "AR", // Argentina
};

export const GANNAR_CURRENCIES = ["CLP", "HNL", "VES", "NIO", "GTQ", "ARS", "USD", "EUR"];

export const COUNTRY_NATIONAL_ID_REGEX = {
	"IL": /^\d{9}$/,
	"AF": /^\d{13}$/,
	"AL": /^[A-Z]\d{8}[A-Z]$/,
	"DZ": /^(0[1-9]|[1-4][0-9]|5[0-8]|99)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{10}$/,
	"AS": /^\d{9}$/,
	"AD": /^[LU]\d{6}[A-Z]$/,
	"AO": /^\d{10}(0[1-9]|1[0-2])\d{2}$/,
	"AI": /^[A-Z0-9]{9}$/,
	"AG": /^[A-Z]{2}\d{6}$/,
	"AR": /^\d{7,8}$/,
	"AM": /^\d{9}$/,
	"AW": /^\d{10}$/,
	"AU": /^(\d{9}|\d{10}[A-Z]?\d{0,2})$/,
	"AT": /^(\d{10}|[A-Z]\d{8})$/,
	"AZ": /^[A-Z]{2}\d{7}$|^[A-Z]\d{8}$/,
	"BS": /^(\d{7}[A-Z]\d{2}|[A-Z]{2}\d{6})$/,
	"BH": /^\d{4}\d{5}$/,
	"BD": /^(\d{10}|\d{13,17}|[A-Z]\d{8})$/,
	"BB": /^[A-Z](0[1-9]|1[0-2])\d{2}\d{5}$/,
	"BY": /^([A-Z]{2}\d{7}|\d{7}[A-Z]\d{6})$/,
	"BE": /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])-\d{3}\.\d{2}$/,
	"BZ": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"BJ": /^(\d{11}|[A-Z]{2}\d{7})$/,
	"BM": /^(\d{6}|[A-Z]{2}\d{7})$/,
	"BT": /^(\d{3}\d{8}|[A-Z]{2}\d{6})$/,
	"BA": /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{4}\d{2}\d{3}\d$/,
	"BW": /^\d{9}$/,
	"BR": /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14})$/,
	"IO": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"BG": /^(\d{10}|\d{9}|\d{13})$/,
	"BF": /^(\d{13}|[A-Z]{2}\d{7})$/,
	"BI": /^(\d{14}|[A-Z]{2}\d{7})$/,
	"KH": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"CM": /^(\d{9}|\d{12}|[A-Z]{2}\d{6})$/,
	"CA": /^(\d{3} ?\d{3} ?\d{3}|[A-Z]{2}\d{6,7})$/,
	"CV": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"KY": /^(\d{9}|[A-Z]{2}\d{6,7})$/,
	"CF": /^(\d{14}|[A-Z]{2}\d{7})$/,
	"TD": /^(\d{14}|[A-Z]{2}\d{6})$/,
	"CL": /^\d{1,2}\.?\d{3}\.?\d{3}-[0-9Kk]$/,
	"CN": /^\d{6}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
	"CX": /^(\d{3} ?\d{3} ?\d{3}|[A-Z]{2}\d{6})$/,
	"CO": /^\d{6,10}(-\d)?$/,
	"KM": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"CG": /^(\d{14}|[A-Z]{2}\d{6})$/,
	"CK": /^(\d{7,10}|[A-Z]{2}\d{6})$/,
	"CR": /^(\d{1}-?\d{4}-?\d{4}|\d{9}|[A-Z]\d{8})$/,
	"HR": /^(\d{11}|[A-Z]{2}\d{7})$/,
	"CU": /^(\d{6}-\d{6}|[A-Z]{2}\d{7})$/,
	"CY": /^(\d{8}[A-Z]|[A-Z]{2}\d{6})$/,
	"CZ": /^(\d{2}(0[1-9]|1[0-2]|5[1-9]|6[0-2])(0[1-9]|[12]\d|3[01])\/?\d{4}|[A-Z]{2}\d{6,7})$/,
	"DK": /^(\d{6}-?\d{4}|[A-Z]{2}\d{7})$/,
	"DJ": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"DM": /^(\d{6,10}|[A-Z]{2}\d{6})$/,
	"DO": /^(\d{11}|[A-Z]{1,2}\d{6,7})$/,
	"EC": /^((0[1-9]|1[0-9]|2[0-4])\d{8}|[A-Z]{1,2}\d{6,7})$/,
	"EG": /^(2|3)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{5}$/,
	"SV": /^(\d{8}-\d{1}|[A-Z]{1,2}\d{6,7})$/,
	"GQ": /^(\d{7,10}|[A-Z]{2}\d{6})$/,
	"ER": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"EE": /^[1-6]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}\d$/,
	"ET": /^(\d{8,10}|[A-Z]{2}\d{6,7})$/,
	"FO": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"FJ": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"FI": /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[-+A]\d{3}[0-9A-Z]$/,
	"FR": /^[12]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{5}\d{2}?$/,
	"GF": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"PF": /^(\d{6,10}|[A-Z]{2}\d{6,7})$/,
	"GA": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"GM": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"GE": /^(\d{11}|[A-Z]{2}\d{7})$/,
	"DE": /^(\d{9}|[A-Z]{2}\d{7})$/,
	"GH": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"GI": /^([A-Z]{2}\d{6}[A-Z]{1}|[A-Z]{1}\d{6,7})$/,
	"GR": /^(\d{9}|[A-Z]{2}\d{6,7})$/,
	"GL": /^(\d{6}-\d{4}|[A-Z]{2}\d{6})$/,
	"GD": /^(\d{9}|[A-Z]{2}\d{6,7})$/,
	"GP": /^(\d{11}|[A-Z]{2}\d{6,7})$/,
	"GU": /^(\d{9}|[A-Z]{2}\d{6,7})$/,
	"GT": /^(\d{8}-\d{3}|[A-Z]{2}\d{7})$/,
	"GN": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"GW": /^(\d{14}|[A-Z]{2}\d{6})$/,
	"GY": /^(\d{7,9}|[A-Z]{2}\d{6,7})$/,
	"HT": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"HN": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"HU": /^(\d{8}-\d{7}|[A-Z]{2}\d{7})$/,
	"IS": /^(\d{6}-\d{4}|[A-Z]{2}\d{6})$/,
	"IN": /^(\d{4}-\d{4}-\d{4}|[A-Z]{1}\d{7})$/,
	"ID": /^(\d{6}\d{8}-\d{4}|[A-Z]{2}\d{6,7})$/,
	"IQ": /^(\d{15}|[A-Z]{2}\d{6,7})$/,
	"IE": /^(\d{7,8}[A-Z]{1}|[A-Z]{2}\d{6})$/,
	"IT": /^([A-Z]{6}\d{2}[A-EHLMPR-T]\d{2}[A-Z]\d{4}[A-Z]|[A-Z]{2}\d{7})$/,
	"JM": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"JP": /^(\d{4}-\d{4}-\d{4}|[A-Z]{2}\d{8})$/,
	"JO": /^(\d{4}\d{2}\d{2}-\d{5}|[A-Z]{2}\d{6})$/,
	"KZ": /^(\d{6}-\d{6}-\d{3}|[A-Z]{2}\d{6})$/,
	"KE": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"KI": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"KW": /^(\d{5}-\d{7}-\d{3}|[A-Z]{2}\d{6})$/,
	"KG": /^(\d{6}-\d{6}-\d{3}|[A-Z]{2}\d{6})$/,
	"LV": /^(\d{6}-\d{6}-\d{3}|[A-Z]{2}\d{6})$/,
	"LB": /^(\d{4}-\d{6}|[A-Z]{2}\d{6})$/,
	"LS": /^(\d{6}|[A-Z]{2}\d{6})$/,
	"LR": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"LI": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"LT": /^(\d{6}-\d{5}|[A-Z]{2}\d{7})$/,
	"LU": /^(\d{4}-\d{5}-\d{3}|[A-Z]{2}\d{6})$/,
	"MG": /^(\d{10}-\d{3}|[A-Z]{2}\d{6})$/,
	"MW": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"MY": /^(\d{6}-\d{5}|[A-Z]{2}\d{7})$/,
	"MV": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"ML": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"MT": /^(\d{7}-\d{1}|[A-Z]{2}\d{6})$/,
	"MH": /^(\d{3}-\d{2}-\d{4}|[A-Z]{2}\d{6})$/,
	"MQ": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"MR": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"MU": /^(\d{6}-[A-Z]{3}-\d{4}|[A-Z]{2}\d{6})$/,
	"YT": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"MX": /^([A-Z]{4}\d{6}[HM]{1}[A-Z]{5}\d{2}|[A-Z]{2}\d{6})$/,
	"MC": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"MN": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"ME": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"MS": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"MA": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"MM": /^(\d{2}\/[A-Z]{3}\([A-Z]{1}\)\d{6}|[A-Z]{2}\d{6})$/,
	"NA": /^(\d{11}|[A-Z]{2}\d{6})$/,
	"NR": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"NP": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"NL": /^(\d{9}|[A-Z]{2}\d{7})$/,
	"AN": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"NC": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"NZ": /^(\d{8,9}|[A-Z]{2}\d{7})$/,
	"NI": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"NE": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"NG": /^(\d{11}|[A-Z]{2}\d{6})$/,
	"NU": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"NF": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"MP": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"NO": /^(\d{11}|[A-Z]{2}\d{6})$/,
	"OM": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"PK": /^(\d{5}-\d{7}-\d{1}|[A-Z]{2}\d{7})$/,
	"PW": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"PA": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"PG": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"PY": /^(\d{7,9}|[A-Z]{2}\d{6})$/,
	"PE": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"PH": /^(\d{12}|[A-Z]{2}\d{6})$/,
	"PL": /^(\d{11}|[A-Z]{2}\d{7})$/,
	"PT": /^(\d{9}|[A-Z]{2}\d{7})$/,
	"PR": /^(\d{3}-\d{2}-\d{4}|[A-Z]{2}\d{6})$/,
	"QA": /^(\d{11}|[A-Z]{2}\d{7})$/,
	"RO": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"RW": /^(\d{16}|[A-Z]{2}\d{6})$/,
	"WS": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"SM": /^([A-Z0-9]{16}|[A-Z]{2}\d{6})$/,
	"SA": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"SN": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"RS": /^(\d{13}|[A-Z]{2}\d{6})$/,
	"SC": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"SL": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"SG": /^([STFG]\d{7}[A-Z]|[A-Z]{2}\d{7})$/,
	"SK": /^(\d{6}-\d{4}|[A-Z]{2}\d{6})$/,
	"SI": /^(\d{6}-\d{5}|[A-Z]{2}\d{6})$/,
	"SB": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"ZA": /^(\d{6}\d{4}\d{3}|[A-Z]{2}\d{7})$/,
	"GS": /^[A-Z]{2}\d{6}$/,
	"ES": /^(\d{8}[A-Z]|[A-Z]\d{7})$/,
	"LK": /^(\d{9}[V]$|\d{12}|[A-Z]\d{7})$/,
	"SD": /^(\d{14}|[A-Z]\d{7})$/,
	"SR": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"SZ": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"SE": /^(\d{8}-\d{4}|[A-Z]\d{6})$/,
	"CH": /^(756\.\d{4}\.\d{4}\.\d{2}|[A-Z]{2}\d{6})$/,
	"TJ": /^(\d{7}|[A-Z]{2}\d{6})$/,
	"TH": /^(\d{13}|[A-Z]\d{8})$/,
	"TG": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"TK": /^[A-Z]\d{7}$/,
	"TO": /^(\d{9}|[A-Z]{2}\d{6})$/,
	"TT": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"TN": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"TR": /^([1-9]\d{10}|[A-Z]{2}\d{7})$/,
	"TM": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"TC": /^[A-Z]{2}\d{7}$/,
	"TV": /^[A-Z]{2}\d{6}$/,
	"UG": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"UA": /^(\d{10}|[A-Z]{2}\d{6})$/,
	"AE": /^(\d{15}|[A-Z]\d{9})$/,
	"GB": /^(?!BG)[A-Z]{2}\d{6}[A-Z]{1}$|^\d{9}$/,
	"US": /^(\d{3}-\d{2}-\d{4}|[A-Z]{2}\d{8})$/,
	"UY": /^(\d{7,8}|[A-Z]{2}\d{6})$/,
	"UZ": /^(\d{9}|[A-Z]\d{7})$/,
	"VU": /^(\d{9}|[A-Z]{2}\d{7})$/,
	"WF": /^[A-Z]{2}\d{7}$/,
	"YE": /^(\d{14}|[A-Z]\d{7})$/,
	"ZM": /^(\d{7}[A-Z]{2}|[A-Z]\d{7})$/,
	"ZW": /^(\d{8}|[A-Z]\d{7})$/,
	"AX": /^[A-Z]{2}\d{6}$/,
	"AQ": /^[A-Z]{2}\d{7}$/,
	"BO": /^(\d{7}[A-Z]|[A-Z]\d{7})$/,
	"BN": /^(\d{6}[A-Z]\d{4}|[A-Z]\d{7})$/,
	"CC": /^[A-Z]{2}\d{7}$/,
	"CD": /^(\d{13}|[A-Z]\d{7})$/,
	"CI": /^(\d{8}|[A-Z]{2}\d{6})$/,
	"FK": /^[A-Z]{2}\d{7}$/,
	"GG": /^[A-Z]{2}\d{6}$/,
	"VA": /^[A-Z]{2}\d{7}$/,
	"HK": /^(\d{6}[A-Z]\(\d\)|[A-Z]\d{7})$/,
	"IR": /^(\d{10}|[A-Z]\d{7})$/,
	"IM": /^(\d{7}[A-Z]|[A-Z]\d{7})$/,
	"JE": /^(\d{7}[A-Z]|[A-Z]\d{7})$/,
	"KP": /^(\d{12}|[A-Z]\d{7})$/,
	"KR": /^(\d{6}-\d{7}|[A-Z]\d{7})$/,
	"LA": /^(\d{9}|[A-Z]\d{7})$/,
	"LY": /^(\d{12}|[A-Z]\d{7})$/,
	"MO": /^(\d{6}[A-Z]\(\d{4}\)|[A-Z]\d{7})$/,
	"MK": /^(\d{13}|[A-Z]\d{7})$/,
	"FM": /^(\d{9}|[A-Z]\d{7})$/,
	"MD": /^(\d{13}|[A-Z]\d{7})$/,
	"MZ": /^(\d{9}|[A-Z]\d{7})$/,
	"PS": /^(\d{9}|[A-Z]\d{7})$/,
	"PN": /^[A-Z]{2}\d{7}$/,
	"RE": /^[A-Z]{2}\d{7}$/,
	"RU": /^(\d{10}(\d{2})?|[A-Z]\d{7})$/,
	"BL": /^[A-Z]{2}\d{7}$/,
	"SH": /^[A-Z]{2}\d{7}$/,
	"KN": /^[A-Z]{2}\d{7}$/,
	"LC": /^[A-Z]{2}\d{7}$/,
	"MF": /^[A-Z]{2}\d{7}$/,
	"PM": /^[A-Z]{2}\d{7}$/,
	"VC": /^[A-Z]{2}\d{7}$/,
	"ST": /^[A-Z]{2}\d{7}$/,
	"SO": /^(\d{7}|[A-Z]\d{7})$/,
	"SJ": /^[A-Z]{2}\d{7}$/,
	"SY": /^(\d{9}|[A-Z]\d{7})$/,
	"TW": /^([A-Z]\d{9}|[A-Z]\d{8})$/,
	"TZ": /^(\d{12}|[A-Z]\d{7})$/,
	"TL": /^(\d{9}|[A-Z]\d{7})$/,
	"VE": /^([V|E]\d{8}[A-Z]|[A-Z]{2}\d{7})$/,
	"VN": /^(\d{9}|[A-Z]\d{7})$/,
	"VG": /^[A-Z]{2}\d{7}$/,
	"VI": /^[A-Z]{2}\d{7}$/,
};

export const COUNTRY_ISO_3166_CODES = [
	{ name: "Afghanistan", code: "AFG" },
	{ name: "Albania", code: "ALB" },
	{ name: "Algeria", code: "DZA" },
	{ name: "AmericanSamoa", code: "ASM" },
	{ name: "Andorra", code: "AND" },
	{ name: "Angola", code: "AGO" },
	{ name: "Anguilla", code: "AIA" },
	{ name: "Antigua and Barbuda", code: "ATG" },
	{ name: "Argentina", code: "ARG" },
	{ name: "Armenia", code: "ARM" },
	{ name: "Aruba", code: "ABW" },
	{ name: "Australia", code: "AUS" },
	{ name: "Austria", code: "AUT" },
	{ name: "Azerbaijan", code: "AZE" },
	{ name: "Bahamas", code: "BHS" },
	{ name: "Bahrain", code: "BHR" },
	{ name: "Bangladesh", code: "BGD" },
	{ name: "Barbados", code: "BRB" },
	{ name: "Belarus", code: "BLR" },
	{ name: "Belgium", code: "BEL" },
	{ name: "Belize", code: "BLZ" },
	{ name: "Benin", code: "BEN" },
	{ name: "Bermuda", code: "BMU" },
	{ name: "Bhutan", code: "BTN" },
	{ name: "Bosnia and Herzegovina", code: "BIH" },
	{ name: "Botswana", code: "BWA" },
	{ name: "Brazil", code: "BRA" },
	{ name: "British Indian Ocean Territory", code: "IOT" },
	{ name: "Bulgaria", code: "BGR" },
	{ name: "Burkina Faso", code: "BFA" },
	{ name: "Burundi", code: "BDI" },
	{ name: "Cambodia", code: "KHM" },
	{ name: "Cameroon", code: "CMR" },
	{ name: "Canada", code: "CAN" },
	{ name: "Cape Verde", code: "CPV" },
	{ name: "Cayman Islands", code: "CYM" },
	{ name: "Central African Republic", code: "CAF" },
	{ name: "Chad", code: "TCD" },
	{ name: "Chile", code: "CHL" },
	{ name: "China", code: "CHN" },
	{ name: "Christmas Island", code: "CXR" },
	{ name: "Colombia", code: "COL" },
	{ name: "Comoros", code: "COM" },
	{ name: "Congo", code: "COG" },
	{ name: "Cook Islands", code: "COK" },
	{ name: "Costa Rica", code: "CRI" },
	{ name: "Croatia", code: "HRV" },
	{ name: "Cuba", code: "CUB" },
	{ name: "Cyprus", code: "CYP" },
	{ name: "Czech Republic", code: "CZE" },
	{ name: "Denmark", code: "DNK" },
	{ name: "Djibouti", code: "DJI" },
	{ name: "Dominica", code: "DMA" },
	{ name: "Dominican Republic", code: "DOM" },
	{ name: "Ecuador", code: "ECU" },
	{ name: "Egypt", code: "EGY" },
	{ name: "El Salvador", code: "SLV" },
	{ name: "Equatorial Guinea", code: "GNQ" },
	{ name: "Eritrea", code: "ERI" },
	{ name: "Estonia", code: "EST" },
	{ name: "Ethiopia", code: "ETH" },
	{ name: "Faroe Islands", code: "FRO" },
	{ name: "Fiji", code: "FJI" },
	{ name: "Finland", code: "FIN" },
	{ name: "France", code: "FRA" },
	{ name: "French Guiana", code: "GUF" },
	{ name: "French Polynesia", code: "PYF" },
	{ name: "Gabon", code: "GAB" },
	{ name: "Gambia", code: "GMB" },
	{ name: "Georgia", code: "GEO" },
	{ name: "Germany", code: "DEU" },
	{ name: "Ghana", code: "GHA" },
	{ name: "Gibraltar", code: "GIB" },
	{ name: "Greece", code: "GRC" },
	{ name: "Greenland", code: "GRL" },
	{ name: "Grenada", code: "GRD" },
	{ name: "Guadeloupe", code: "GLP" },
	{ name: "Guam", code: "GUM" },
	{ name: "Guatemala", code: "GTM" },
	{ name: "Guinea", code: "GIN" },
	{ name: "Guinea-Bissau", code: "GNB" },
	{ name: "Guyana", code: "GUY" },
	{ name: "Haiti", code: "HTI" },
	{ name: "Honduras", code: "HND" },
	{ name: "Hungary", code: "HUN" },
	{ name: "Iceland", code: "ISL" },
	{ name: "India", code: "IND" },
	{ name: "Indonesia", code: "IDN" },
	{ name: "Iraq", code: "IRQ" },
	{ name: "Ireland", code: "IRL" },
	{ name: "Israel", code: "ISR" },
	{ name: "Italy", code: "ITA" },
	{ name: "Jamaica", code: "JAM" },
	{ name: "Japan", code: "JPN" },
	{ name: "Jordan", code: "JOR" },
	{ name: "Kazakhstan", code: "KAZ" },
	{ name: "Kenya", code: "KEN" },
	{ name: "Kiribati", code: "KIR" },
	{ name: "Kuwait", code: "KWT" },
	{ name: "Kyrgyzstan", code: "KGZ" },
	{ name: "Latvia", code: "LVA" },
	{ name: "Lebanon", code: "LBN" },
	{ name: "Lesotho", code: "LSO" },
	{ name: "Liberia", code: "LBR" },
	{ name: "Liechtenstein", code: "LIE" },
	{ name: "Lithuania", code: "LTU" },
	{ name: "Luxembourg", code: "LUX" },
	{ name: "Madagascar", code: "MDG" },
	{ name: "Malawi", code: "MWI" },
	{ name: "Malaysia", code: "MYS" },
	{ name: "Maldives", code: "MDV" },
	{ name: "Mali", code: "MLI" },
	{ name: "Malta", code: "MLT" },
	{ name: "Marshall Islands", code: "MHL" },
	{ name: "Martinique", code: "MTQ" },
	{ name: "Mauritania", code: "MRT" },
	{ name: "Mauritius", code: "MUS" },
	{ name: "Mayotte", code: "MYT" },
	{ name: "Mexico", code: "MEX" },
	{ name: "Monaco", code: "MCO" },
	{ name: "Mongolia", code: "MNG" },
	{ name: "Montenegro", code: "MNE" },
	{ name: "Montserrat", code: "MSR" },
	{ name: "Morocco", code: "MAR" },
	{ name: "Myanmar", code: "MMR" },
	{ name: "Namibia", code: "NAM" },
	{ name: "Nauru", code: "NRU" },
	{ name: "Nepal", code: "NPL" },
	{ name: "Netherlands", code: "NLD" },
	{ name: "Netherlands Antilles", code: "ANT" },
	{ name: "New Caledonia", code: "NCL" },
	{ name: "New Zealand", code: "NZL" },
	{ name: "Nicaragua", code: "NIC" },
	{ name: "Niger", code: "NER" },
	{ name: "Nigeria", code: "NGA" },
	{ name: "Niue", code: "NIU" },
	{ name: "Norfolk Island", code: "NFK" },
	{ name: "Northern Mariana Islands", code: "MNP" },
	{ name: "Norway", code: "NOR" },
	{ name: "Oman", code: "OMN" },
	{ name: "Pakistan", code: "PAK" },
	{ name: "Palau", code: "PLW" },
	{ name: "Panama", code: "PAN" },
	{ name: "Papua New Guinea", code: "PNG" },
	{ name: "Paraguay", code: "PRY" },
	{ name: "Peru", code: "PER" },
	{ name: "Philippines", code: "PHL" },
	{ name: "Poland", code: "POL" },
	{ name: "Portugal", code: "PRT" },
	{ name: "Puerto Rico", code: "PRI" },
	{ name: "Qatar", code: "QAT" },
	{ name: "Romania", code: "ROU" },
	{ name: "Rwanda", code: "RWA" },
	{ name: "Samoa", code: "WSM" },
	{ name: "San Marino", code: "SMR" },
	{ name: "Saudi Arabia", code: "SAU" },
	{ name: "Senegal", code: "SEN" },
	{ name: "Serbia", code: "SRB" },
	{ name: "Seychelles", code: "SYC" },
	{ name: "Sierra Leone", code: "SLE" },
	{ name: "Singapore", code: "SGP" },
	{ name: "Slovakia", code: "SVK" },
	{ name: "Slovenia", code: "SVN" },
	{ name: "Solomon Islands", code: "SLB" },
	{ name: "South Africa", code: "ZAF" },
	{ name: "South Georgia and the South Sandwich Islands", code: "SGS" },
	{ name: "Spain", code: "ESP" },
	{ name: "Sri Lanka", code: "LKA" },
	{ name: "Sudan", code: "SDN" },
	{ name: "Suriname", code: "SUR" },
	{ name: "Swaziland", code: "SWZ" },
	{ name: "Sweden", code: "SWE" },
	{ name: "Switzerland", code: "CHE" },
	{ name: "Tajikistan", code: "TJK" },
	{ name: "Thailand", code: "THA" },
	{ name: "Togo", code: "TGO" },
	{ name: "Tokelau", code: "TKL" },
	{ name: "Tonga", code: "TON" },
	{ name: "Trinidad and Tobago", code: "TTO" },
	{ name: "Tunisia", code: "TUN" },
	{ name: "Turkey", code: "TUR" },
	{ name: "Turkmenistan", code: "TKM" },
	{ name: "Turks and Caicos Islands", code: "TCA" },
	{ name: "Tuvalu", code: "TUV" },
	{ name: "Uganda", code: "UGA" },
	{ name: "Ukraine", code: "UKR" },
	{ name: "United Arab Emirates", code: "ARE" },
	{ name: "United Kingdom", code: "GBR" },
	{ name: "United States", code: "USA" },
	{ name: "Uruguay", code: "URY" },
	{ name: "Uzbekistan", code: "UZB" },
	{ name: "Vanuatu", code: "VUT" },
	{ name: "Wallis and Futuna", code: "WLF" },
	{ name: "Yemen", code: "YEM" },
	{ name: "Zambia", code: "ZMB" },
	{ name: "Zimbabwe", code: "ZWE" },
	{ name: "land Islands", code: "ALA" },
	{ name: "Antarctica", code: "ATA" },
	{ name: "Bolivia, Plurinational State of", code: "BOL" },
	{ name: "Brunei Darussalam", code: "BRN" },
	{ name: "Cocos (Keeling) Islands", code: "CCK" },
	{ name: "Congo, The Democratic Republic of the", code: "COD" },
	{ name: "Cote d'Ivoire", code: "CIV" },
	{ name: "Falkland Islands (Malvinas)", code: "FLK" },
	{ name: "Guernsey", code: "GGY" },
	{ name: "Holy See (Vatican City State)", code: "VAT" },
	{ name: "Hong Kong", code: "HKG" },
	{ name: "Iran, Islamic Republic of", code: "IRN" },
	{ name: "Isle of Man", code: "IMN" },
	{ name: "Jersey", code: "JEY" },
	{ name: "Korea, Democratic People's Republic of", code: "PRK" },
	{ name: "Korea, Republic of", code: "KOR" },
	{ name: "Lao People's Democratic Republic", code: "LAO" },
	{ name: "Libyan Arab Jamahiriya", code: "LBY" },
	{ name: "Macao", code: "MAC" },
	{ name: "Macedonia, The Former Yugoslav Republic of", code: "MKD" },
	{ name: "Micronesia, Federated States of", code: "FSM" },
	{ name: "Moldova, Republic of", code: "MDA" },
	{ name: "Mozambique", code: "MOZ" },
	{ name: "Palestinian Territory, Occupied", code: "PSE" },
	{ name: "Pitcairn", code: "PCN" },
	{ name: "Réunion", code: "REU" },
	{ name: "Russia", code: "RUS" },
	{ name: "Saint Barthélemy", code: "BLM" },
	{ name: "Saint Helena, Ascension and Tristan Da Cunha", code: "SHN" },
	{ name: "Saint Kitts and Nevis", code: "KNA" },
	{ name: "Saint Lucia", code: "LCA" },
	{ name: "Saint Martin", code: "MAF" },
	{ name: "Saint Pierre and Miquelon", code: "SPM" },
	{ name: "Saint Vincent and the Grenadines", code: "VCT" },
	{ name: "Sao Tome and Principe", code: "STP" },
	{ name: "Somalia", code: "SOM" },
	{ name: "Svalbard and Jan Mayen", code: "SJM" },
	{ name: "Syrian Arab Republic", code: "SYR" },
	{ name: "Taiwan, Province of China", code: "TWN" },
	{ name: "Tanzania, United Republic of", code: "TZA" },
	{ name: "Timor-Leste", code: "TLS" },
	{ name: "Venezuela, Bolivarian Republic of", code: "VEN" },
	{ name: "Viet Nam", code: "VNM" },
	{ name: "Virgin Islands, British", code: "VGB" },
	{ name: "Virgin Islands, U.S.", code: "VIR" },
];

export const BANK_LIST = [
	{
		"id": "akbank",
		"bankName": "AKBANK T.A.Ş",
	},
	// {
	//   "id": "aktifbank",
	//   "bankName": "Aktifbank"
	// },
	{
		"id": "adabank",
		"bankName": "ADABANK A.Ş.",
	},
	{
		"id": "kuveytturk",
		"bankName": "KUVEYTTÜRK",
	},
	// {
	// 	"id": "sekerbank",
	// 	"bankName": "ŞEKERBANK",
	// },
	// {
	// 	"id": "albarakaturk",
	// 	"bankName": "ALBARAKA TÜRK KATILIM BANKASI A.Ş",
	// },
	{
		"id": "anadolubank",
		"bankName": "ANADOLUBANK A.Ş",
	},
	// {
	// 	"id": "asyakatilim",
	// 	"bankName": "ASYA KATILIM BANKASI A.Ş",
	// },
	{
		"id": "bankpozitif",
		"bankName": "BANKPOZİTİF KREDİ VE KALKINMA BANKASI A.Ş",
	},
	{
		"id": "denizbank",
		"bankName": "DENİZBANK A.Ş",
	},
	// {
	// 	"id": "finansbank",
	// 	"bankName": "FINANSBANK",
	// },
	// {
	// 	"id": "fibabanka",
	// 	"bankName": "FİBABANKA A.Ş",
	// },
	{
		"id": "hsbc",
		"bankName": "HSBC BANK A.Ş",
	},
	{
		"id": "icbc",
		"bankName": "ICBC TURKEY BANK ANONİM ŞİRKETİ",
	},
	// {
	// 	"id": "ing",
	// 	"bankName": "ING BANK A.Ş",
	// },
	// {
	// 	"id": "kuveytturk",
	// 	"bankName": "KUVEYT TÜRK KATILIM BANKASI A.Ş",
	// },
	{
		"id": "odeabank",
		"bankName": "ODEA BANK A.Ş",
	},
	// {
	// 	"id": "sekerbank",
	// 	"bankName": "ŞEKERBANK T.A.Ş",
	// },
	{
		"id": "teb",
		"bankName": "TÜRK EKONOMİ BANKASI A.Ş",
	},
	// {
	// 	"id": "turkiyefinans",
	// 	"bankName": "TÜRKİYE FİNANS KATILIM BANKASI A.Ş",
	// },
	{
		"id": "garanti",
		"bankName": "TÜRKİYE GARANTİ BANKASI A.Ş",
	},
	{
		"id": "isbank",
		"bankName": "TÜRKİYE İŞ BANKASI A.Ş",
	},
	{
		"id": "vakifbank",
		"bankName": "TÜRKİYE VAKIFLAR BANKASI T.A.O",
	},
	{
		"id": "ykb",
		"bankName": "YAPI VE KREDİ BANKASI A.Ş",
	},
];

export const BETTER_BRO_CHILE_BANKS = [
	{ name: "Banco de Chile - Edwards", code: "001" },
	{ name: "Banco Internacional", code: "009" },
	{ name: "Banco Estado", code: "012" },
	{ name: "Scotiabank", code: "014" },
	{ name: "BCI", code: "016" },
	{ name: "Banco Bice", code: "028" },
	{ name: "HSBC Bank", code: "031" },
	{ name: "Banco Santander", code: "037" },
	{ name: "Itau Chile", code: "039" },
	{ name: "Banco Security", code: "049" },
	{ name: "Banco Falabella", code: "051" },
	{ name: "Banco Ripley", code: "053" },
	{ name: "Banco Consorcio", code: "055" },
	{ name: "Coopeuch (Dale)", code: "672" },
	{ name: "Prepago Los Heroes", code: "729" },
];

export const SPORTS = {
	"sr:sport:1": "Soccer",
	"sr:sport:2": "Basketball",
	"sr:sport:3": "Baseball",
	"sr:sport:4": "Ice Hockey",
	"sr:sport:5": "Tennis",
	"sr:sport:6": "Handball",
	"sr:sport:7": "Floorball",
	"sr:sport:8": "Trotting",
	"sr:sport:9": "Golf",
	"sr:sport:10": "Boxing",
	"sr:sport:11": "Motorsport",
	"sr:sport:12": "Rugby",
	"sr:sport:13": "Aussie Rules",
	"sr:sport:14": "Winter Sports",
	"sr:sport:15": "Bandy",
	"sr:sport:16": "American Football",
	"sr:sport:17": "Cycling",
	"sr:sport:18": "Specials",
	"sr:sport:19": "Snooker",
	"sr:sport:20": "Table Tennis",
	"sr:sport:21": "Cricket",
	"sr:sport:22": "Darts",
	"sr:sport:23": "Volleyball",
	"sr:sport:24": "Field hockey",
	"sr:sport:25": "Pool",
	"sr:sport:26": "Waterpolo",
	"sr:sport:27": "Gaelic sports",
	"sr:sport:28": "Curling",
	"sr:sport:29": "Futsal",
	"sr:sport:30": "Olympics",
	"sr:sport:31": "Badminton",
	"sr:sport:32": "Bowls",
	"sr:sport:33": "Chess",
	"sr:sport:34": "Beach Volley",
	"sr:sport:35": "Netball",
	"sr:sport:36": "Athletics",
	"sr:sport:37": "Squash",
	"sr:sport:38": "Rink Hockey",
	"sr:sport:39": "Lacrosse",
	"sr:sport:40": "Formula 1",
	"sr:sport:41": "Bikes",
	"sr:sport:42": "DTM",
	"sr:sport:43": "Alpine Skiing",
	"sr:sport:44": "Biathlon",
	"sr:sport:45": "Bobsleigh",
	"sr:sport:46": "Cross-Country",
	"sr:sport:47": "Nordic Combined",
	"sr:sport:48": "Ski Jumping",
	"sr:sport:49": "Snowboard",
	"sr:sport:50": "Speed Skating",
	"sr:sport:51": "Luge",
	"sr:sport:52": "Swimming",
	"sr:sport:53": "Finnish Baseball",
	"sr:sport:54": "Softball",
	"sr:sport:55": "Horse racing",
	"sr:sport:56": "Schwingen",
	"sr:sport:57": "Inline Hockey",
	"sr:sport:58": "Greyhound",
	"sr:sport:59": "Rugby League",
	"sr:sport:60": "Beach Soccer",
	"sr:sport:61": "Pesapallo",
	"sr:sport:62": "Streethockey",
	"sr:sport:63": "World Championship",
	"sr:sport:64": "Rowing",
	"sr:sport:65": "Freestyle",
	"sr:sport:66": "Snowboardcross/Parallel",
	"sr:sport:67": "MotoGP",
	"sr:sport:68": "Moto2",
	"sr:sport:69": "Moto3",
	"sr:sport:70": "Nascar",
	"sr:sport:71": "Padel Tennis",
	"sr:sport:72": "Canoeing",
	"sr:sport:73": "Horseball",
	"sr:sport:74": "Aquatics",
	"sr:sport:75": "Archery",
	"sr:sport:76": "Equestrian",
	"sr:sport:77": "Fencing",
	"sr:sport:78": "Gymnastics",
	"sr:sport:79": "Judo",
	"sr:sport:80": "Modern Pentathlon",
	"sr:sport:81": "Sailing",
	"sr:sport:82": "Shooting",
	"sr:sport:83": "Taekwondo",
	"sr:sport:84": "Triathlon",
	"sr:sport:85": "Weightlifting",
	"sr:sport:86": "Wrestling",
	"sr:sport:87": "Olympics Youth",
	"sr:sport:88": "Mountain Bike",
	"sr:sport:89": "Riding",
	"sr:sport:90": "Surfing",
	"sr:sport:91": "BMX racing",
	"sr:sport:92": "Canoe slalom",
	"sr:sport:93": "Rhythmic gymnastics",
	"sr:sport:94": "Trampolining",
	"sr:sport:95": "Synchronized swimming",
	"sr:sport:96": "Diving",
	"sr:sport:97": "Track cycling",
	"sr:sport:98": "Beach Tennis",
	"sr:sport:99": "Sumo",
	"sr:sport:100": "Superbike",
	"sr:sport:101": "Rally",
	"sr:sport:102": "Figure Skating",
	"sr:sport:103": "Freestyle Skiing",
	"sr:sport:104": "Skeleton",
	"sr:sport:105": "Short Track",
	"sr:sport:106": "Soccer Mythical",
	"sr:sport:107": "eSport",
	"sr:sport:108": "World Lottery",
	"sr:sport:109": "Counter-Strike",
	"sr:sport:110": "League of Legends",
	"sr:sport:111": "Dota 2",
	"sr:sport:112": "StarCraft",
	"sr:sport:113": "Hearthstone",
	"sr:sport:114": "Heroes of the Storm",
	"sr:sport:115": "World of Tanks",
	"sr:sport:116": "Polo",
	"sr:sport:117": "MMA",
	"sr:sport:118": "Call of Duty",
	"sr:sport:119": "Smite",
	"sr:sport:120": "Vainglory",
	"sr:sport:121": "Overwatch",
	"sr:sport:122": "WarCraft III",
	"sr:sport:123": "Crossfire",
	"sr:sport:124": "Halo",
	"sr:sport:125": "Rainbow Six",
	"sr:sport:126": "Sepak Takraw",
	"sr:sport:127": "Street Fighter V",
	"sr:sport:128": "Rocket League",
	"sr:sport:129": "Indycar",
	"sr:sport:130": "Basque Pelota",
	"sr:sport:131": "Speedway",
	"sr:sport:132": "ESport Gears of War",
	"sr:sport:133": "ESport Clash Royale",
	"sr:sport:134": "ESport King of Glory",
	"sr:sport:135": "Gaelic Football",
	"sr:sport:136": "Gaelic Hurling",
	"sr:sport:137": "ESport FIFA",
	"sr:sport:138": "Kabaddi",
	"sr:sport:139": "ESport Quake",
	"sr:sport:140": "ESport PlayerUnknowns Battlegrounds",
	"sr:sport:141": "Cycling Cycle Ball",
	"sr:sport:142": "Formula E",
	"sr:sport:143": "7BallRun",
	"sr:sport:144": "Motocross",
	"sr:sport:145": "Sprint Car Racing",
	"sr:sport:146": "Speed Boat Racing",
	"sr:sport:147": "Drag Racing",
	"sr:sport:148": "Stock Car Racing",
	"sr:sport:149": "Modified Racing",
	"sr:sport:150": "Off Road",
	"sr:sport:151": "Truck & Tractor Pulling",
	"sr:sport:152": "ESport World of Warcraft",
	"sr:sport:153": "ESport NBA2K",
	"sr:sport:154": "ESport Dragon Ball FighterZ",
	"sr:sport:155": "Basketball 3x3",
	"sr:sport:156": "ESport Tekken",
	"sr:sport:157": "Beach Handball",
	"sr:sport:158": "ESport Arena of Valor",
	"sr:sport:159": "ESport TF2",
	"sr:sport:160": "ESport SSBM",
	"sr:sport:161": "ESport Paladins",
	"sr:sport:162": "ESport Artifact",
	"sr:sport:163": "Indoor Soccer",
	"sr:sport:164": "ESport Apex Legends",
	"sr:sport:165": "Indy Lights",
	"sr:sport:166": "ESport Pro Evolution Soccer",
	"sr:sport:167": "ESport Madden NFL",
	"sr:sport:168": "ESport Brawl Stars",
	"sr:sport:169": "Petanque",
	"sr:sport:170": "ESport Fortnite",
	"sr:sport:171": "ESport MTG",
	"sr:sport:172": "Fishing",
	"sr:sport:173": "Esport Dota Underlords",
	"sr:sport:174": "Esport Teamfight Tactics",
	"sr:sport:175": "Esport Auto Chess",
	"sr:sport:176": "Esport Fighting Games",
	"sr:sport:177": "SC",
	"sr:sport:178": "ESport Motorsport",
};
